import { all, fork } from "redux-saga/effects";
import * as Loginsaga from "../Containers/Login/Login-saga";
import * as Productsaga from "../Containers/Product/Product-saga";
import * as Categorysaga from "../Containers/Category/Category-saga";
import * as Homesaga from "../Containers/Home/Home-saga";
import * as Dashboardsaga from "../Containers/Dashboard/Dashboard-saga";
import * as AnalyticsSaga from "../Containers/Analytics/Analytics-saga";
import * as OrderSaga from "../Containers/Order/Order-saga";
import * as AccountSaga from "../Containers/Accounts/Account-saga";

export default function* rootSaga() {
  const login = Object.values(Loginsaga).map((saga) => {
    return fork(saga);
  });

  const Product = Object.values(Productsaga).map((saga) => {
    return fork(saga);
  }); 
  const Category = Object.values(Categorysaga).map((saga) => {
    return fork(saga);
  });
  const Home = Object.values(Homesaga).map((saga) => {
    return fork(saga);
  });
  const Dashboard = Object.values(Dashboardsaga).map((saga) => {
    return fork(saga);
  });
  const Analytics = Object.values(AnalyticsSaga).map((saga) => {
    return fork(saga);
  });
  const Order = Object.values(OrderSaga).map((saga) => {
    return fork(saga);
  });
  const Account = Object.values(AccountSaga).map((saga) => {
    return fork(saga);
  });
  yield all([
    ...login,
    ...Product,
    ...Category,
    ...Home,
    ...Dashboard,
    ...Analytics,
    ...Order,
    ...Account,
  ]);
}
